<template>
    <v-dialog :value="true" @input="$emit('dismissed', true)" min-width="400" max-width="600" width="95%">
        <v-card>

            <v-card-title>
                {{ title }}
            </v-card-title>

            <v-card-text class="body-1" v-html="prompt"></v-card-text>

            <v-card-actions class="d-flex justify-end px-1">
                <v-btn
                        class="mx-1"
                        v-for="(btn, i) in btns"
                        :key="i"
                        v-bind="btn.attrs"
                        @click="$emit('action', btn.value)"
                >
                    <v-icon
                            v-if="btn.icon"
                            left
                    >
                        {{btn.icon}}
                    </v-icon>
                    {{btn.text}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: {type: String, default: "Prompt"},
        prompt: {type: String, default: "Prompt"},
        buttons: {
            type: Array,
            default: () => {
                return [
                    {
                        text: "Cancel",
                        attrs: {},
                        value: null
                    }
                ]
            }
        }
    },
    data() {
        return {
            console,
        }
    },
    computed: {
        btns() {
            return this.buttons.map((btn) => {
                const obj = {text: "Cancel", attrs: {}, value: null}
                Object.assign(obj, btn)
                obj.value = obj.value || obj.text
                if (btn.normal) obj.attrs = {color: 'primary'}
                if (btn.cancel) obj.attrs = {text: true, plain: true}
                return obj
            })
        }
    },
}
</script>

<style scoped>

</style>